import type { ReactNode } from 'react';
import styles from './Badge.module.css';

export interface BadgeProps {
  variant?: 'default' | 'success' | 'warning' | 'danger';
  className?: string;
  children: ReactNode;
}

export function Badge({
  variant = 'default',
  className,
  children,
}: BadgeProps) {
  return (
    <span data-crd-id="r2.bq-badge" data-crd-layer="r2" className={`${styles.badge} ${styles[variant]} ${className ?? ''}`}>
      {children}
    </span>
  );
}
